import api from "@/modules/client/services/client";

const state = () => ({
    clients: [],
    existingClient: {},
    apiRslt: {
        fetch: {
            inProgress: false,
            success: false,
            error: false,
        }
    }
})

const getters = {
}

const actions = {
    loadClients({commit}) {
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.getClients().then(result => {
            commit('SET_API_DATA_FETCH_SUCCESS')
            commit('SAVE_CLIENT', result.data);
        }).catch(e => {
            commit('SET_API_DATA_FETCH_ERROR', e)
        });
    },
    updateClient({ commit,dispatch }, payload){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.putClient(payload.id, payload)
            .then(() => {
                commit('SET_API_DATA_FETCH_SUCCESS')
                commit('UPDATE_CLIENT', payload);
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION001', extra: 'client' },{ root:true })
            })
            .catch((e) => {
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION001', extra: 'client' },{ root:true })
                commit('SET_API_DATA_FETCH_ERROR', e)
            });
    },
    deleteClient({ commit,dispatch }, id){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.deleteClient(id)
            .then(() => {
                commit('SET_API_DATA_FETCH_SUCCESS')
                commit('DELETE_CLIENT',id)
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION003', extra: 'client' },{ root:true })
            })
            .catch((e) => {
                commit('SET_API_DATA_FETCH_ERROR', e)
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION003', extra: 'client' },{ root:true })
            })

    }
}

const mutations = {
    UPDATE_CLIENT (state,payload){
        state.clients = state.clients.map(customer => {
            if (customer.id === payload.id) {
                return Object.assign({}, customer, payload.data)
            }
            return customer
        })
    },
    DELETE_CLIENT (state, id){
        const index = state.clients.findIndex(c => c._id === id);
        state.clients.splice(index, 1);
    },
    SAVE_CLIENT(state, clients) {
        state.clients = clients;
    },
    SET_API_DATA_FETCH_IN_PROGRESS: (state) => {
        state.apiRslt.fetch.inProgress = true
        state.apiRslt.fetch.completed = false
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_SUCCESS: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = true
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_ERROR: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = true
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
